export const decemberAbbreviatedLowercase = "$pa";
export default {decemberAbbreviatedLowercase};